<template>
  <div id="auswertung_user">
    <div class="row">
      <div class="col-xs-12">
        <div v-for="land in data" :key="land.LAND">
          <b>{{ land.LAND }}</b>
          <img width="30px" :src="land.FLAGGE" />
          <br />
          <img width="200px" :src="land.BANNER" />
          <ul>
            <li v-for="(item, index) in land.kommentare" :key="land.LAND+index">{{ item }}</li>
          </ul>
          <hr style="margin-bottom: 20px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  import config from '../config'

export default {
  props: ['auswertung'],
  watch: {
    auswertung() {
      this.getData();
    }
  },
  data () {
    return {
      data: []
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let token = this.$store.state.token;
      axios.get(config.apiServerAdress + '/kommentare', {headers: {'x-access-token': token}})
        .then(res => {
          const data = res.data;
          const rank = [];

          for (let key in data) {
            const r = data[key];
            rank.push(r);
          }

          this.data = this.groupByCountry(rank);
        })
        .catch(error => {
          console.log(error);
        })
    },
    groupByCountry(countries) {
      const result = [];
      for (let index in countries) {
        const country = countries[index];
        const land = country.LAND;
        const bannerUrl = country.BANNER;
        const flagUrl = country.FLAGGE;
        const kommentare = countries.filter(item => item.LAND === land).map(item => item.KOMMENTAR);

        const vorhanden = result.find(vorhanden => vorhanden.LAND === land);
        if (vorhanden == null) {
          result.push({LAND: land, BANNER: bannerUrl, FLAGGE: flagUrl, kommentare: kommentare});
        }

      }
      return result;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
